import {
    FETCH_ORDER_BOOKING_ACTIVITIES,
    FETCH_ORDER_BOOKING_ACTIVITIES_FAILURE,
    FETCH_ORDER_BOOKING_ACTIVITIES_SUCCESS,
} from 'store/actions/types';

export const fetchOrderBookingActivities = (payload) => {
    return {
        type: FETCH_ORDER_BOOKING_ACTIVITIES,
        payload: payload,
    };
};

export const fetchOrderBookingActivitiesFailure = (payload) => {
    return {
        type: FETCH_ORDER_BOOKING_ACTIVITIES_FAILURE,
        payload: payload,
    };
};

export const fetchOrderBookingActivitiesSuccess = (payload) => {
    return {
        type: FETCH_ORDER_BOOKING_ACTIVITIES_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/orderActivitiesActions.js